export default __webpack_public_path__ + "static/media/32-Tranquility.4f301a65.jpeg";